<div class="right-side p-5">
  <h2>Add Customize Feedback Questions</h2>
    <div class="section">
      <form [formGroup]="form">

        <div class="card mb-3">
          <div class="card-header"> <h2>Custom Feedback Question</h2></div>
          <div class="row" style="padding-left: 15px;">
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                <mat-label>Intervention</mat-label>
                <mat-select formControlName="intervention" (selectionChange)="onSelectInterventionChange($event)">
                  <mat-option *ngFor="let option of interventionList" [value]="option.id">
                    {{ option.text }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('intervention')?.hasError('required') && form.get('intervention')?.touched">
                  Intervention is required.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field appearance="outline">
                <mat-label>Component</mat-label>
                <mat-select formControlName="component" (selectionChange)="onSelectComponentChange($event)">
                  <mat-option *ngFor="let option of componentList" [value]="option.id">
                    {{ option.text }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('component')?.hasError('required') && form.get('component')?.touched">
                  Intervention is required.
                </mat-error>
              </mat-form-field>
            </div>


          </div>
          <hr />
          <div class="card-body">
            <!-- Custom Feedback Question -->
            <div class="row text-start mb-3">
              <div class="col-md-5 mb-2">
                <label class="nowrap">All Question</label>
                <div class="interest-selection-box">
                  <div *ngFor="let question of allCustomQuestion" class="form-check">
                    <input type="checkbox"
                           class="form-check-input"
                           [checked]="question.selected"
                           (change)="toggleQuestionSelection(question, $event)" />
                    <label class="form-check-label">
                      {{ question.questionDetails }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-1 mb-2 text-center">
                <button class="btn btn-sm btn-primary my-2 me-2" (click)="moveSelectedToRight()">
                  <i class="bi bi-arrow-right"></i>
                </button>
                <button class="btn btn-sm btn-primary my-2" (click)="moveSelectedToLeft()">
                  <i class="bi bi-arrow-left"></i>
                </button>
              </div>

              <div class="col-md-5 mb-2">
                <label class="nowrap">Selected Question</label>
                <div class="selected-interests-box">
                  <div *ngFor="let selectedQuestion of selectedQuestions" class="form-check">
                    <input type="checkbox"
                           class="form-check-input"
                           [checked]="selectedQuestion.selected"
                           (change)="toggleQuestionSelection(selectedQuestion, $event)" />
                    <label class="form-check-label">
                      {{ selectedQuestion.questionDetails }}
                    </label>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="col-md-12 text-center">
          <button class="btn btn-success" type="button" (click)="onSubmit()">Submit</button>
        </div>

      </form>
    </div>
</div>
